import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import InsightArticleTemplate from '../features/insights-v2/components/InsightArticleTemplate';
import {
  getInsightV2PostBySlug,
  getNextInsightV2Post,
  listInsightV2Posts,
} from '../features/insights-v2/content';
import { usePublicPublicationBySlug, usePublicPublications } from '../hooks/usePublications';

export default function InsightV2ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const publicPublications = usePublicPublications();
  const publicationBySlug = usePublicPublicationBySlug(slug ?? null, Boolean(slug));

  const mergedPosts = useMemo(
    () => listInsightV2Posts(publicPublications.data),
    [publicPublications.data],
  );
  const post = publicationBySlug.data ?? getInsightV2PostBySlug(slug, mergedPosts);
  const nextPost = getNextInsightV2Post(slug, mergedPosts);

  if (!post && (publicPublications.isLoading || publicationBySlug.isLoading)) {
    return <div style={{ padding: '2rem' }}>Loading…</div>;
  }

  if (!post) {
    return <Navigate to="/publications" replace />;
  }

  return <InsightArticleTemplate post={post} nextPost={nextPost} />;
}
